export default __webpack_public_path__ + "static/media/kitchen5-beforeE-1024w.28242693.webp";